export default __webpack_public_path__ + "static/header-desk-b9575d24cb8003b3a7b20bf8ff0ca6e3.jpg";